module.exports = __webpack_public_path__ + "static/media/twitterX-white.85f32125.svg";